export const getWorkflows = (state) => {
  return state.workflows;
};
